export const UILabel = ({ children, htmlFor, className = "" }) => (
  <label
    htmlFor={htmlFor}
    className={`block mb-2 text-sm font-medium text-gray-900 ${className}`}
  >
    {children}
  </label>
);
